/* Modern dark surfaces, layered over dark.css: a near-black canvas, slightly
   raised neutral cards, hairline translucent borders instead of bright
   outlines, and a soft violet accent. */
:root {
  --color-pageBackground: var(--palette-gray900);
  --color-pageBackgroundModalActive: var(--palette-gray800);
  --color-pageTextPositive: var(--palette-purple200);
  --color-pageTextLink: var(--palette-purple300);

  --color-cardBackground: var(--palette-gray800);
  --color-cardBorder: rgba(255, 255, 255, 0.07);
  --color-cardShadow: rgba(0, 0, 0, 0.5);

  --color-tableBackground: var(--palette-gray800);
  --color-tableHeaderBackground: #1d1d22;
  --color-tableRowHeaderBackground: #1d1d22;
  --color-tableRowBackgroundHover: #212127;
  --color-tableBorder: rgba(255, 255, 255, 0.07);
  --color-tableBorderSeparator: rgba(255, 255, 255, 0.14);
  --color-tableRowBackgroundHighlight: rgba(130, 111, 248, 0.18);
  --color-tableHeaderText: var(--palette-gray300);

  --color-sidebarBackground: #121215;
  --color-sidebarItemBackgroundHover: rgba(255, 255, 255, 0.06);
  --color-sidebarBorder: rgba(255, 255, 255, 0.07);
  --color-sidebarRedesignRightBorder: rgba(255, 255, 255, 0.07);

  --color-menuBackground: #1d1d22;
  --color-menuItemBackground: #1d1d22;
  --color-menuItemBackgroundHover: rgba(255, 255, 255, 0.07);
  --color-menuBorder: rgba(255, 255, 255, 0.09);
  --color-menuAutoCompleteBackground: #1d1d22;
  --color-menuAutoCompleteBackgroundHover: rgba(255, 255, 255, 0.07);

  --color-modalBackground: var(--palette-gray800);
  --color-modalBorder: rgba(255, 255, 255, 0.09);
  --color-tooltipBackground: #1d1d22;
  --color-tooltipBorder: rgba(255, 255, 255, 0.09);

  --color-buttonPrimaryBackground: var(--palette-purple500);
  --color-buttonPrimaryBackgroundHover: var(--palette-purple400);
  --color-buttonPrimaryShadow: rgba(0, 0, 0, 0.4);
  --color-buttonNormalBackground: #1f1f24;
  --color-buttonNormalBackgroundHover: #2a2a31;
  --color-buttonNormalBorder: rgba(255, 255, 255, 0.1);
  --color-buttonNormalShadow: rgba(0, 0, 0, 0.3);
  --color-buttonNormalDisabledBackground: #1a1a1e;
  --color-buttonNormalDisabledBorder: rgba(255, 255, 255, 0.06);
  --color-buttonMenuBorder: rgba(255, 255, 255, 0.1);

  --color-formInputBackground: #141417;
  --color-formInputBackgroundSelected: #18181c;
  --color-formInputBorder: rgba(255, 255, 255, 0.1);
  --color-formInputBorderSelected: var(--palette-purple400);
  --color-formInputShadowSelected: rgba(130, 111, 248, 0.35);
  --color-formInputTextPlaceholder: var(--palette-gray400);

  --color-pillBackground: #24242a;
  --color-pillBorder: rgba(255, 255, 255, 0.08);

  --color-calendarBackground: var(--palette-gray900);
  --color-calendarItemBackground: var(--palette-gray800);
  --color-calendarCellBackground: var(--palette-gray900);

  --color-budgetOtherMonth: #131316;
  --color-budgetHeaderOtherMonth: #18181c;

  --color-mobileHeaderBackground: var(--palette-gray800);
  --color-mobilePageBackground: var(--palette-gray900);
  --color-mobileNavBackground: var(--palette-gray800);

  --color-overlayBackground: rgba(0, 0, 0, 0.55);

  --shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.4);
  --shadow-md: 0 1px 2px rgba(0, 0, 0, 0.35), 0 4px 14px rgba(0, 0, 0, 0.3);
  --shadow-lg: 0 8px 24px rgba(0, 0, 0, 0.45), 0 24px 56px rgba(0, 0, 0, 0.4);
  --focus-ring: 0 0 0 3px rgba(130, 111, 248, 0.3);
}
